export default __webpack_public_path__ + "static/media/lqid.bbdfbf59.svg";